
const digest = 'a0364ed20782792a45e6cfa93d7da5a32af0336b49868fbcb6fdd93d6e6949e9';
const classes = {"wrapper":"_wrapper_1wnsd_1","header":"_header_1wnsd_8","title":"_title_1wnsd_14","controls":"_controls_1wnsd_17"};
const css = `._wrapper_1wnsd_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
}
._wrapper_1wnsd_1 ._header_1wnsd_8 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}
._wrapper_1wnsd_1 ._header_1wnsd_8 ._title_1wnsd_14 {
  font-weight: 500;
}
._wrapper_1wnsd_1 ._header_1wnsd_8 ._controls_1wnsd_17 {
  display: flex;
  gap: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  